import { Dropdown, IconButton, Icons, Menu, MenuButton, MenuItem, Tooltip } from '@healthinal/ui';
import { useAtom } from 'jotai';
import { useState } from 'react';
import { TaskSortDirection } from '../../../api/created/tasks.ts';
import { taskSortDirAtom } from '../../../state/taskSearchAtoms.ts';

const SORT_OPTIONS: { value: TaskSortDirection; label: string }[] = [
  { value: 'asc', label: 'Älteste' },
  { value: 'desc', label: 'Neueste' },
];

function getSortTooltipLabel(sortDir: TaskSortDirection) {
  return sortDir === 'asc' ? 'Älteste' : 'Neueste';
}

export function TaskSortMenu() {
  const [sortDir, setSortDir] = useAtom(taskSortDirAtom);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const selectSortDir = (nextSortDir: TaskSortDirection) => {
    setSortDir(nextSortDir);
    setIsMenuOpen(false);
  };

  return (
    <Dropdown
      open={isMenuOpen}
      onOpenChange={(event) => event?.type !== 'click' && setIsMenuOpen((prevState) => !prevState)}>
      <Tooltip title={getSortTooltipLabel(sortDir)}>
        <MenuButton
          slots={{ root: IconButton }}
          slotProps={{ root: { variant: 'soft', color: 'neutral' } }}
          onClick={() => setIsMenuOpen((prevState) => !prevState)}>
          <Icons.UnfoldMore />
        </MenuButton>
      </Tooltip>
      <Menu placement={'bottom-end'}>
        {SORT_OPTIONS.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => selectSortDir(option.value)}
            startDecorator={sortDir === option.value ? <Icons.Check /> : undefined}>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </Dropdown>
  );
}
